import { render, staticRenderFns } from "./ApwPlanThreshold.vue?vue&type=template&id=7908dc51&scoped=true&"
import script from "./ApwPlanThreshold.vue?vue&type=script&lang=js&"
export * from "./ApwPlanThreshold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908dc51",
  null
  
)

export default component.exports